import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import styles from './Tabs.module.scss';

export type Tab<T> = {
  name: T;
  title: string;
  className?: string;
};

export type TabsProps<T> = {
  tabs: Tab<T>[];
  activeTab: string;
  onTabClick: (tab: Tab<T>) => void;
};

export const Tabs = observer(
  <T,>({ tabs, activeTab, onTabClick }: TabsProps<T>) => (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.name as string}
          className={clsx(styles.tab, {
            [styles.active]: tab.name === activeTab,
          })}
          onClick={() => onTabClick(tab)}
        >
          {tab.title}
        </button>
      ))}
    </div>
  ),
);
